import { render, staticRenderFns } from "./PriceResult.vue?vue&type=template&id=1c22a477&scoped=true&"
import script from "./PriceResult.vue?vue&type=script&lang=js&"
export * from "./PriceResult.vue?vue&type=script&lang=js&"
import style0 from "./PriceResult.vue?vue&type=style&index=0&id=1c22a477&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c22a477",
  null
  
)

export default component.exports